import React from 'react';
import { connect } from 'react-redux';

import { interpolate } from '@/utils';
import { CmsPageContentIdentifier, CmsPageContentType, ReduxStateType } from '@/types/av-check';

export interface StateProps {
  cmsContent: CmsPageContentType,
}

export interface AlertBoxProps {
  type: string,
  contentIdentifier: CmsPageContentIdentifier
}

const DtagFtthAlertBox = ({
  cmsContent,
  type,
  contentIdentifier,
}: StateProps & AlertBoxProps) => {
  const content = cmsContent[contentIdentifier];
  let contentParams = {};
  const finalContent = content != null ? interpolate(content, contentParams) : '';
  const css = `
              .dtag-alert {
               padding: 15px 10px 15px 95px;
               border: 1px solid transparent;
               position: relative;
               }
               .dtag-alert-danger {
               background-color: transparent;
               border-color: #f65d7c;
               }
              .dtag-alert-danger:before {
              content: "\\f10b";
              font-family: o2icons;
              color: #f65d7c;
              }
              .dtag-alert:before {
              display: inline-block;
              font-family: o2icons;
              font-style: normal;
              font-weight: 400;
              line-height: 1;
              /* -webkit-font-smoothing: antialiased; */
              -moz-osx-font-smoothing: grayscale;
              top: 50%;
              -webkit-transform: translateY(-50%);
              transform: translateY(-50%);
              position: absolute;
              left: 25px;
              font-size: 50px;
             }
             @media (max-width: 768px)
            .dtag-alert.dtag-alert-danger{
             width: 100% !important;
             padding: 20px 33px 20px 90px !important;
             }
             #dtag-alert-text p{           
                color: #c04961 !important;
             }
            `;
  return (
      <>
        <style>
          {css}
        </style>
        <div
            className={`dtag-alert dtag-alert-${type}`}
            role="alert"
        >
          <p id='dtag-alert-text' dangerouslySetInnerHTML={{ __html: finalContent }}/>
        </div>
      </>
  );
};

const mapStateToProps = (state: ReduxStateType) => ({
  cmsContent: state.cmsContent,
});

export default connect(mapStateToProps)(DtagFtthAlertBox);
